import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { MapPinOff } from 'lucide-react';

export function DropsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="drops" className="py-32 px-6 relative overflow-hidden" data-testid="drops-section" ref={ref}>
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#FFC700]/15 to-transparent" />

      <div className="max-w-3xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <span className="mono-tag text-[#FFC700]">// SECTION :: DROPS</span>
          <h2 className="section-title mt-4">DROPS</h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="terminal-panel mt-10 inline-block text-left"
          data-testid="drops-panel"
        >
          <div className="terminal-panel-header">
            <span className="terminal-panel-dot" />
            <MapPinOff size={11} />
            ZATO::DROPS
          </div>
          <div className="p-6 text-center">
            <p className="font-mono text-sm text-white/40 tracking-widest mb-2" data-testid="drops-status">
              STATUS // DORMANT
            </p>
            <p className="font-mono text-xs text-white/20">
              Nothing has been hidden yet.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
